import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "center"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref } from 'vue';
import { useStore } from 'vuex';
import { generateNewStyle, writeNewStyle } from '@/utils/theme.js';
export default {
  __name: 'SelectColor',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const store = useStore();
    const emits = __emit;

    // 预定义色值
    const predefineColors = ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577'];

    // 默认色值
    const mColor = ref(store.getters.mainColor);
    const closed = () => {
      emits('update:modelValue', false);
    };
    const comfirm = async () => {
      // 1. 生成新的 css 样式,立即生效。刷新后是在app.vue中获取vuex中的值设置的
      const newStyleText = await generateNewStyle(mColor.value);
      writeNewStyle(newStyleText);
      // 2. 保存最新的主题色
      store.commit('theme/setMainColor', mColor.value);
      // 3. 关闭 dialog
      closed();
    };
    return (_ctx, _cache) => {
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "提示",
        "model-value": __props.modelValue,
        onClose: closed,
        width: "22%"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: closed
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('msg.universal.cancel')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: comfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('msg.universal.confirm')), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('msg.theme.themeColorChange')), 1), _createVNode(_component_el_color_picker, {
          modelValue: mColor.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => mColor.value = $event),
          predefine: predefineColors
        }, null, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};